import { Switch } from 'react-router-dom'
import { Route } from 'react-router'
import IdleTimer from 'react-idle-timer'

// Pages
import Home from '../pages/Home'
import MapSearch from 'pages/MapSearch'
import Calendar from '../pages/Calendar'
import Reservation from '../pages/Reservation'
import Login from '../pages/Login'
import Accepted from '../pages/Accepted'
import Logout from '../pages/Logout'
import Tracing from '../pages/Tracing'
import CampusServiceTracing from 'pages/CampusServiceTracing'
import NotificationService from '../service/NotificationService'
import Dashboard from '../pages/Dashboard'
import SurveyEvaluations from 'pages/SurveyEvaluations'
import RemoteOfficeNotification from 'pages/RemoteOfficeNotification'

export default function RouterConfig() {
  return (
    <div className={'container-fluid p-0'}>
      <Switch>
        <Route path="/" exact={true} component={Login} />
        <Route path="/login" exact={true} component={Login} />
        <Route path="/accepted" component={Accepted} />
        <Route path="/logout" component={Logout} />
        <IdleTimer timeout={31 * 60 * 1000} onIdle={onIdle}>
          <Route path="/home" component={Home} />
          <Route path="/evaluation" component={SurveyEvaluations} />
          <Route path="/map" component={MapSearch} />
          <Route path="/calendar" component={Calendar} />
          <Route path="/reservation" component={Reservation} />
          <Route path="/tracing" exact={true} component={Tracing} />
          <Route path="/firm-tracing" exact={true} component={Tracing} />
          <Route path="/campus-service-tracing" component={CampusServiceTracing} />
          <Route path="/remote-office-notification" component={RemoteOfficeNotification} />
          <Route path="/dashboard" component={Dashboard} />
        </IdleTimer>
      </Switch>
    </div>
  )
}

function onIdle() {
  NotificationService.showUnauthorizedRedirectionPopup().then(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('employee')
    localStorage.removeItem('kvkkDisplay')
    localStorage.removeItem('employeePhoto')
    localStorage.setItem('webApiKey', 'empty')
    window.location.href = '/'
  })
}
